import React from 'react';
import { ProcessorMetadata, PROCESSOR_COLORS } from '../../types/processor';

interface ProcessorCardProps {
  processor: ProcessorMetadata;
  onDragStart: (e: React.DragEvent, processor: ProcessorMetadata) => void;
  showDescription?: boolean;
}

export const ProcessorCard: React.FC<ProcessorCardProps> = ({
  processor,
  onDragStart,
  showDescription = true,
}) => {
  // Normalize processor_type to uppercase (backend returns lowercase)
  const processorType = (processor.processor_type?.toUpperCase() || 'SCRIPTED') as 'SCRIPTED' | 'AGENTIC' | 'UTILITY';
  const colors = PROCESSOR_COLORS[processorType];

  return (
    <div
      draggable
      onDragStart={(e) => onDragStart(e, processor)}
      className={`
        ${colors.border} ${colors.bg}
        border-l-4 rounded-lg p-3 mb-2 cursor-move
        hover:shadow-md transition-shadow duration-200
        dark:border-opacity-80
      `}
      data-testid="processor-card"
    >
      {/* Processor Name */}
      <div className={`font-semibold text-sm ${showDescription ? 'mb-1' : ''} ${colors.text}`}>
        {processor.display_name || processor.processor_name}
      </div>

      {/* Description - Conditional rendering */}
      {showDescription && (
        <div className="text-xs text-gray-600 dark:text-gray-400">
          {processor.description}
        </div>
      )}
    </div>
  );
};

